import { useState } from "react";
import { formatINR, formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";
import EduSection from "@/components/EduSection";

export default function RentalYield() {
  const [value, setValue] = useState("8000000");
  const [monthlyRent, setMonthlyRent] = useState("25000");
  const [expenses, setExpenses] = useState("30000");
  const annualRent = (Number(monthlyRent)||0) * 12;
  const gross = (Number(value)||0) > 0 ? (annualRent / Number(value)) * 100 : 0;
  const net = (Number(value)||0) > 0 ? ((annualRent - (Number(expenses)||0)) / Number(value)) * 100 : 0;
  const rows = [
    ["Property Value", formatINR(Number(value)||0)],
    ["Monthly Rent", formatINR(Number(monthlyRent)||0)],
    ["Annual Rent", formatINR(annualRent)],
    ["Annual Expenses", formatINR(Number(expenses)||0)],
    ["Gross Yield", `${formatNumber(gross,2)}%`],
    ["Net Yield", `${formatNumber(net,2)}%`],
  ];
  return (
    <div>
      <CalcPageHeader title="Rental Yield Calculator" description="Gross & net rental yield on any property investment." slug="rental-yield" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 space-y-4">
            <Field label="Property Value (₹)"><input data-testid="ry-value" type="number" value={value} onChange={(e)=>setValue(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <div className="grid grid-cols-2 gap-4">
              <Field label="Monthly Rent (₹)"><input data-testid="ry-rent" type="number" value={monthlyRent} onChange={(e)=>setMonthlyRent(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
              <Field label="Annual Expenses (₹)" hint="Maintenance, tax, vacancy"><input data-testid="ry-exp" type="number" value={expenses} onChange={(e)=>setExpenses(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            </div>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Rental Yield" slug="rental-yield" highlight={{ label: "Net Yield", value: `${formatNumber(net,2)}%`, sub: `Gross ${formatNumber(gross,2)}%` }} rows={rows} />
        </div>
      </div>
      <EduSection howItWorks={<p>Gross Yield = (Annual Rent ÷ Property Value) × 100. Net Yield subtracts annual expenses first.</p>} faqs={[{q:"What's a good rental yield in India?",a:"Residential typically 2-4%; commercial 6-9%."}]} related={["property-roi","warehouse-rent","loan-emi"]} />
    </div>
  );
}
